import { number_from_query, str_from_query } from "@/api";
import { axios_instance } from "@/api/api";
import { router } from "@/router/router";
import { defineStore } from "pinia";
import { computed, onMounted, ref, watch } from "vue";
import { toast } from "vue3-toastify";
import type { installed_app } from ".";

export const use_installed_apps = defineStore("installed_apps", () => {
  const installed_apps = ref<installed_app[]>([]);
  const loading = ref<{
    [key: string]: boolean;
  }>({
    get_installed_apps: false,
  });
  const total_filter = ref<number>(0);
  const total_pages = computed(() =>
    Math.max(1, total_filter.value / number_from_query("size", 24)),
  );

  const get_installed_apps = () => {
    const action_id = router.currentRoute.value.params.action_id;
    if (!action_id) return;

    const data = JSON.stringify({
      action_id: router.currentRoute.value.params.action_id,
      page: number_from_query("page", 1),
      size: number_from_query("size", 24),
      keyword: str_from_query("keyword"),
    });

    const config = {
      method: "post",
      maxBodyLength: Infinity,
      url: "/api/v1/view/app-install/pagination",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios_instance
      .request<{ data: installed_app[] | null; total_filter: number }>(config)
      .then((response) => {
        if (response.data) {
          installed_apps.value = response.data.data ?? [];
          total_filter.value = response.data.total_filter;
        }
      })
      .catch((error) => {
        toast.error(error);
      });
  };

  onMounted(() => {
    get_installed_apps();
  });

  watch(
    () => [router.currentRoute.value.query],
    () => {
      if (router.currentRoute.value.name !== "ClientApplicationScanDetail")
        return;
      get_installed_apps();
    },
  );

  return {
    installed_apps,
    loading,
    total_filter,
    total_pages,
    get_installed_apps,
  };
});
